import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/app-shield/headerRightBg.png';
import headerRightBg375 from '../images/app-shield/headerRightBg375.png';
import ManShieldPapers from '../images/app-shield/ManShieldPapers.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import ChecklistScreen from '../images/app-shield/ChecklistScreen.svg';
import DuplicateApplications from '../images/app-shield/DuplicateApplications.svg';
import Servers from '../images/app-shield/Servers.svg';
import ScreenSortApplications from '../images/app-shield/ScreenSortApplications.svg';
import WantToSeeHow from '../components/WantToSeeHow';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const indexHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `80px`}}>
		<h1>AppShield</h1>
		<p>Protect underwriters<br />with data validation</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 80%;
		margin-top: 2em;
		margin-bottom: 2em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 464px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const ManShieldPapersFigure =
	<HeaderBottomContentFigure>
		<ManShieldPapers alt='Woman holding mangnifying glass' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	border: none;
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };
const TheSolutionStyleLargeUp  = { paddingRight: '0' };

const AppShieldPage = (props: any) => {
	return (
	<Layout
		headerSplashBg={headerRightBg}
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPosition={'right bottom'}
		headerSplashBgPositionLarge={'center top'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={ManShieldPapersFigure}
		headerContentClass={'product'}
		headerContent={indexHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='AppShield - Application filtering'
		metaDescription={'Filter applications from known fraudulent, delinquent, Insider (Reg O), or repeat customers to save your underwriters precious time and prevent fraud.{'}
		skipMoney2020={true}
		splashHeaderMinHeight={'410px'}
		BodyClass={'AppShield'}
	>
		<ProblemSolution
			problem={"Financial institutions are losing valuable time underwriting when reviewing repeat applications from fraudulent, delinquent, or Insider (Reg O) customers. Additionally, customers' credit scores are negatively impacted by repetitive credit pulls."}
			solution={'AppShield saves financial institutions time by restricting applications from known fraudulent, delinquent or Insider (Reg O) customers. In addition, it prevents unnecessary credit pulls on repeat applications.'}
			solutionExtraStyle={TheSolutionStyleLargeUp}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3498d3'}

			leftIcon = {<ChecklistScreen alt='checklist on screen icon' style={{margin: `0`}} />}
			leftHeading = {'Restricted\ncustomer lists'}
			leftText={'Filter applications from fraudulent, delinquent, or insider (Reg O) customers.'}

			middleIcon = {<DuplicateApplications alt='Duplicate applications icon' style={{margin: `9px 0`}} />}
			middleHeading = {'Repeat application\nidentification'}
			middleText = {'Increase underwriting efficiency by eliminating repeat applications.'}

			rightIcon = {<Servers alt='Servers blocking data icon' style={{margin: `15px 0`}} />}
			rightHeading = {'Invalid data\nentry detection'}
			rightText = {'Ensure quality of data on credit applications by detecting errors.'}
		/>
		<div className='centeredWrapper'>
			<Section className='strategic-fraud row row-flush centered'>
				<article className='col-12 col-md-6 right-on-desktop'>
					<div className='product text-box'>
						<header>
							<h2>Ensure underwriters have quality data</h2>
						</header>
						<p>Underwriting is time-consuming, so why bottleneck the process? Set loan officers up for success by filtering out application data that should be prohibited from the start. Increase operational efficiency by uploading restricted customer lists to prevent repeat applications and immediately issue Adverse Action Letters.</p><p>Free up underwriters' time to concentrate on quality applications. To top it off, build customer confidence by saving them from harmful, repeat credit pulls.</p>
					</div>
				</article>
				<figure className='col-12 col-md-6 left-on-desktop' id='ScreenSortApplications'>
					<ScreenSortApplications alt='Screen sorting applications' />
				</figure>
			</Section>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default AppShieldPage;
